export default "__VITE_ASSET__Caol7XN2__"